const DateUnits = Object.freeze({
  Hours: 'hour',
  Days: 'day',
});

export default DateUnits;
